module.exports = "<app-library isKeyView=\"true\"></app-library>"